import React from "react";

import { animated } from "@react-spring/web";

import { SwipeProps } from "./types";
import { useMarketsSwipe } from "./hooks";

export const Swipe = (props: SwipeProps) => {
  const { getSwipeProps } = useMarketsSwipe(props);
  return <animated.div {...getSwipeProps()}>{props.children}</animated.div>;
};
